import type { FormEvent, ReactNode } from "react";

export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="rounded-md border border-(--saa-danger)/40 bg-(--saa-danger)/10 px-3 py-2 text-sm text-(--saa-danger)">
      {message}
    </p>
  );
}

export function Form({ onSubmit, children, label }: { onSubmit: () => void; children: ReactNode; label: string }) {
  return (
    <form
      aria-label={label}
      className="flex flex-col gap-4"
      noValidate
      onSubmit={(e: FormEvent) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      {children}
    </form>
  );
}

export function Notice({ children }: { children: ReactNode }) {
  return (
    <p role="status" className="rounded-md border border-(--saa-border) bg-(--saa-muted) px-3 py-2 text-sm">
      {children}
    </p>
  );
}

export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-xl font-semibold">{title}</h1>
      {actions}
    </div>
  );
}
